import {
  ITreatmentViewModel,
  ITreatmentNoteViewModel,
  ITreatmentContactViewModel,
  ITreatmentFilterChangeViewModel,
  ITreatmentData,
  ITreatmentSampleViewModel,
} from "app/models/household/treatment";
import {
  Component,
  OnInit,
  Inject,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { FormControl, FormGroup } from "@angular/forms";
import { HousingUnitService } from "app/services/housingunit-service";
import { PartnerService } from "app/services/partner-service";
import { IHousingUnit } from "app/models/housingunits/housing-unit";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { DialogLinkTreatmentComponent } from "app/components/well/samples/link/link-treatment-dialog";
import { IPartnerAccess } from "app/models/partners/partners";
/*
 * Add Treatment Dialog
 */

@Component({
  selector: "dialog-add-treatment",
  templateUrl: "add-treatment-dialog.html",
  styleUrls: ["./add-treatment-dialog.scss"],
})
export class DialogAddTreatmentComponent implements OnInit {
  @Input("housingUnitId")
  housingUnitId: number = 0;
  @Input("treatmentId")
  treatmentId: number = 0;

  loading: boolean = true;
  processing: boolean = false;
  housingUnit: IHousingUnit = undefined;
  postErrorMessages: string = "";
  buttonText: string = "Add";
  contacts: ITreatmentContactViewModel[] = [];
  notes: ITreatmentNoteViewModel[] = [];
  filterChanges: ITreatmentFilterChangeViewModel[] = [];
  treatmentSamples: ITreatmentSampleViewModel[] = [];
  partners: IPartnerAccess[] = [];
  assignedPartner: number = 0;
  installedByOptions: any[] = [];

  treatmentData: ITreatmentData = {
    sharedWell: false,
    highestNitrateTestResult: 0,
    lastSampleCollectionDate: "",
    dateOfFirstTier3Sample: "",
    dateOfHighestNitrateResult: "",
  };

  treatment: ITreatmentViewModel = {
    treatmentId: 0,
    existingTreatmentSystem: "",
    systemInstallationPriority: "",
    housingUnitId: 0,
    roSystemRefused: false,
    systemInstalled: "",
    statusOfInstall: "",
    treatmentInstallCompletionDate: null,
    latestFilterChangeDate: null,
    reasonForRefusal: "",
    installedBy: "",
    describeExistingSystem: "",
    treatmentSamples: [],
    assignedPartnerId: 0,
  };

  treatmentForm = new FormGroup({
    roSystemRefused: new FormControl({ value: false, disabled: false }),
    systemInstalled: new FormControl(""),
    statusOfInstall: new FormControl(""),
    treatmentInstallCompletionDate: new FormControl(""),
    existingTreatmentSystem: new FormControl(""),
    systemInstallationPriority: new FormControl(""),
    reasonForRefusal: new FormControl(""),
    installedBy: new FormControl(""),
    describeExistingSystem: new FormControl(""),
    assignedPartnerId: new FormControl(""),
  });

  constructor(
    public housingUnitService: HousingUnitService,
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    public partnerService: PartnerService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: number[],
    private dialogRef: MatDialogRef<DialogAddTreatmentComponent>
  ) {
    this.housingUnitId = this.data["housingUnitId"] ?? 0;
    this.treatmentId = this.data["treatmentId"];
  }

  ngOnInit(): void {
    /*if (this.data["housingUnitId"] <= 0) {
      this.toastr.error("Invalid Housing Unit Id");
      this.dialogRef.close();
      this.loading = false;
    } else {
      
    }*/
    this.treatment.housingUnitId = this.housingUnitId;
    this.getPartners();
    if (this.housingUnitId <= 0) //otherwise loadTreatment doesnt get called
      this.loadTreatment();
    this.addContact(); //show at least one contact
    this.addNote(); //show at least one note
    this.addFilterChange(); //show at least one note 
  }

  populateInstalledByOptions() {
    this.assignedPartner = Number(this.treatmentForm.value.assignedPartnerId);
    if (this.assignedPartner > 0) {
      this.partnerService.getPartner(this.assignedPartner).subscribe(
        (result) => {
          this.treatmentForm.get("installedBy").enable();
          this.installedByOptions = result.passKeys;
          this.loadTreatmentFilterChanges();
        },
        (error) => {
          this.toastr.error("Unable to load Partner Users");
        }
      );
    } else {
      this.installedByOptions = [];
      this.treatmentForm.get("installedBy").disable();
      this.treatmentForm.get("installedBy").setValue("");
    }
  }

  getPartners() {
    this.partnerService.getAll().subscribe(
      (result) => {
        this.partners = result;
        this.loadHousingUnit();
      },
      (error) => {
        this.toastr.error("Unable to load Partners");
      }
    );
  }

  loadHousingUnit() {
    if (this.housingUnitId <= 0)
      return;

    this.housingUnitService.getHousingUnitById(this.housingUnitId).subscribe(
      (result) => {
        this.housingUnit = result;
        this.loadSampleData();
      },
      (error) => {
        this.toastr.error("Unable to load Housing Unit");
      }
    );
  }

  loadSampleData() {
    if (this.housingUnitId <= 0)
      return;

    this.housingUnitService.getTreatmentData(this.housingUnitId).subscribe(
      (result) => {
        this.treatmentData = result;
        this.loadTreatment();
      },
      (error) => {
        this.toastr.error("Unable to load Sample Data");
      }
    );
  }

  loadTreatmentContacts() {
    this.housingUnitService.getTreatmentContacts(this.treatmentId).subscribe(
      (result) => {
        this.contacts = result;

        for (let i = 0; i < this.contacts.length; i++) {
          this.contacts[i].dateOfContact = new Date(this.contacts[i].dateOfContact).toISOString();
        }

        if (this.contacts.length == 0) this.addContact(); //show at least one contact
      },
      (error) => {
        this.toastr.error("Unable to load Contacts");
      }
    );
  }

  loadTreatmentNotes() {
    this.housingUnitService.getTreatmentNotes(this.treatmentId).subscribe(
      (result) => {
        this.notes = result;

        if (this.notes.length == 0) this.addNote(); //show at least one note
      },
      (error) => {
        this.toastr.error("Unable to load Notes");
      }
    );
  }

  loadTreatmentFilterChanges() {
    // validate this.treatmentId
    if (this.treatmentId <= 0) {
      return;
    }

    this.housingUnitService
      .getTreatmentFilterChanges(this.treatmentId)
      .subscribe(
        (result) => {
          this.filterChanges = result;

          for (let i = 0; i < this.filterChanges.length; i++) {
            this.filterChanges[i].filterChangeDate = new Date(this.filterChanges[i].filterChangeDate).toISOString();
          }

          if (this.filterChanges.length == 0)
            this.addFilterChange(); //show at least one Filter Change
        },
        (error) => {
          this.toastr.error("Unable to load Filter Changes");
        }
      );
  }

  loadTreatment() {
    if (this.data["treatmentId"] > 0) {
      this.housingUnitService.getTreatment(this.treatmentId).subscribe(
        (result) => {
          this.treatment = result;
          this.buttonText = "Save";
          this.setFormValues();
          this.populateInstalledByOptions();
          this.loadTreatmentContacts();
          this.loadTreatmentNotes();

        },
        (error) => {
          this.toastr.error("Unable to load Treatment");
          this.loading = false;
          this.dialogRef.close();
        }
      );
    } else {
      this.cd.detectChanges();
      this.loading = false;
    }
  }

  disableEnableInput(value) {
    if (value === "Yes")
      this.treatmentForm.get("describeExistingSystem").enable();
    else {
      this.treatmentForm.get("describeExistingSystem").disable();
      this.treatmentForm.get("describeExistingSystem").setValue("");
    }

    this.cd.detectChanges();
  }

  setFormValues() {
    this.treatmentForm.get("roSystemRefused").setValue(this.treatment.roSystemRefused);
    if (this.treatment.assignedPartnerId && this.treatment.assignedPartnerId > 0) {
      this.treatmentForm.get("assignedPartnerId").setValue(this.treatment.assignedPartnerId.toString());
    }
    this.treatmentForm.get("systemInstalled").setValue(this.treatment.systemInstalled);
    this.treatmentForm.get("statusOfInstall").setValue(this.treatment.statusOfInstall);
    this.treatmentForm.get("reasonForRefusal").setValue(this.treatment.reasonForRefusal);
    this.treatmentForm.get("installedBy").setValue(this.treatment.installedBy);
    this.treatmentForm.get("existingTreatmentSystem").setValue(this.treatment.existingTreatmentSystem);
    this.treatmentForm.get("systemInstallationPriority").setValue(this.treatment.systemInstallationPriority);
    this.treatmentForm.get("describeExistingSystem").setValue(this.treatment.describeExistingSystem);
    this.treatmentForm.get("treatmentInstallCompletionDate")
      .setValue(
        this.treatment.treatmentInstallCompletionDate
          ? new Date(
            this.treatment.treatmentInstallCompletionDate
          ).toISOString()
          : new Date().toISOString()
      );
    this.treatment.treatmentId = this.treatmentId;
    //this.cd.detectChanges();
    this.loading = false;
  }

  getFormValues() {
    this.treatment.existingTreatmentSystem = this.treatmentForm.value.existingTreatmentSystem;
    this.treatment.systemInstallationPriority = this.treatmentForm.value.systemInstallationPriority;
    this.treatment.roSystemRefused = this.treatmentForm.value.roSystemRefused;
    this.treatment.systemInstalled = this.treatmentForm.value.systemInstalled;
    this.treatment.statusOfInstall = this.treatmentForm.value.statusOfInstall;
    this.treatment.treatmentInstallCompletionDate = this.treatmentForm.value
      .treatmentInstallCompletionDate
      ? new Date(
        this.treatmentForm.value.treatmentInstallCompletionDate
      ).toISOString()
      : null;
    this.treatment.reasonForRefusal = this.treatmentForm.value.reasonForRefusal;
    this.treatment.installedBy = this.treatmentForm.value.installedBy;
    this.treatment.describeExistingSystem = this.treatmentForm.value.describeExistingSystem;
    this.treatment.assignedPartnerId = Number(this.treatmentForm.value.assignedPartnerId);
  }

  saveTreatment() {
    this.processing = true;
    this.getFormValues();

    this.housingUnitService.saveTreatment(this.treatment).subscribe(
      (result) => {
        this.setTreatementID4Contracts(result);
        this.saveContacts();
        this.setTreatementID4Notes(result);
        this.saveNotes();
        this.setTreatementID4FilterChanges(result);
        this.saveFilterChanges();
        this.toastr.success("Treatment Saved");
      },
      (error) => {
        this.toastr.error("Unable to Save treatment: " + error.message);
        this.processing = false;
      },
      () => {
        this.dialogRef.close();
      }
    );
  }

  setTreatementID4FilterChanges = (id) => {
    this.filterChanges = this.filterChanges.map((obj) => ({
      ...obj,
      treatmentId: id,
    }));
  };

  linkSample() {
    const dialogRef = this.dialog.open(DialogLinkTreatmentComponent, {
      width: "90%",
      data: {
        treatmentId: this.treatment.treatmentId,
        voucherId: "",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result > 0) {
        this.linkTreatmentToSample(result);
      }
    });
  }

  linkTreatmentToSample(sampleId: number) {
    this.processing = true;
    this.housingUnitService
      .linkTreatmentToSample(this.treatmentId, sampleId)
      .subscribe(
        (result) => {
          this.treatment.treatmentSamples.push(result);
          this.processing = false;
        },
        (error) => {
          this.toastr.error(
            "Unable to link treatment to sample Id: " +
            sampleId +
            " " +
            error.message
          );
          this.processing = false;
        }
      );
  }

  unlinkSample(idx: number, sampleId: number) {
    if (sampleId > 0)
      this.sharedService.openConfirm(
        "Are you sure you want to unlink this sample? This will happen automatically."
      );

    this.sharedService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.loading = true;
        this.housingUnitService
          .unlinkTreatmentSample(this.treatmentId, sampleId)
          .subscribe(
            (result) => {
              this.toastr.success("Sample Unlinked");
              this.treatment.treatmentSamples.splice(idx, 1);
              this.loading = false;
            },
            (error) => {
              this.toastr.error("Unable to Save treatment: " + error.message);
              this.processing = false;
              this.loading = false;
            }
          );
      }
    });
  }

  saveFilterChanges() {
    if (this.filterChanges.length == 0) return;

    this.housingUnitService
      .saveTreatmentFilterChanges(this.filterChanges)
      .subscribe(
        (result) => {
          this.processing = false;
        },
        (error) => {
          this.toastr.error("Unable to Save filter changes: " + error.message);
          this.processing = false;
        },
        () => { }
      );
  }

  addFilterChange() {
    const filterChange: ITreatmentFilterChangeViewModel = {
      treatmentId: this.treatment.treatmentId ?? 0,
      treatmentFilterChangeId: 0,
      passKey: null,
      comments: "",
      filterChangeDate: "",
      status: "new",
    };

    this.filterChanges.push(filterChange);
  }

  deleteFilterChange(id: number, filterChangeId: number) {
    if (filterChangeId > 0)
      this.sharedService.openConfirm(
        "Are you sure you want to remove this filter change? (You will still need to Update the treatment to completely remove the filter change)"
      );
    else this.removeFilterChange(id);

    this.sharedService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.removeFilterChange(id);
      }
    });
  }

  removeFilterChange(id: number) {
    this.filterChanges[id]["status"] = "deleted";
    this.cd.detectChanges();
  }

  setTreatementID4Notes = (id) => {
    this.notes = this.notes.map((obj) => ({ ...obj, treatmentId: id }));
  };

  saveNotes() {
    if (this.notes.length == 0) return;

    this.housingUnitService.saveTreatmentNotes(this.notes).subscribe(
      (result) => {
        this.processing = false;
      },
      (error) => {
        this.toastr.error("Unable to Save notes: " + error.message);
        this.processing = false;
      },
      () => { }
    );
  }

  addNote() {
    const note: ITreatmentNoteViewModel = {
      treatmentId: this.treatment.treatmentId ?? 0,
      treatmentNoteId: 0,
      comments: "",
      status: "new",
    };

    this.notes.push(note);
  }

  deleteNote(id: number, noteId: number) {
    if (noteId > 0)
      this.sharedService.openConfirm(
        "Are you sure you want to remove this note? (You will still need to Update the treatment to completely remove the note)"
      );
    else this.removeNote(id);

    this.sharedService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.removeNote(id);
      }
    });
  }

  removeNote(id: number) {
    this.notes[id]["status"] = "deleted";
    this.cd.detectChanges();
  }

  setTreatementID4Contracts = (id) => {
    this.contacts = this.contacts.map((obj) => ({ ...obj, treatmentId: id }));
  };

  saveContacts() {
    if (this.contacts.length == 0) return;

    /* for (let i = 0; i < this.contacts.length; i++) { 
        this.contacts[i].outcome = this.treatmentForm.value['contactDateOfContact' + i];
        this.contacts[i].dateOfContact = new Date(this.treatmentForm.value['contactOutcome' + i]).toLocaleDateString();
      }   */

    this.housingUnitService.saveTreatmentContacts(this.contacts).subscribe(
      (result) => {
        this.processing = false;
      },
      (error) => {
        this.toastr.error("Unable to Save contacts: " + error.message);
        this.processing = false;
      },
      () => { }
    );
  }

  addContact() {
    const contact: ITreatmentContactViewModel = {
      treatmentId: this.treatment.treatmentId ?? 0,
      treatmentContactId: 0,
      outcome: "",
      contactedBy: "",
      dateOfContact: "",
      status: "new",
    };

    this.contacts.push(contact);
  }

  deleteContact(id: number, contactId: number) {
    if (contactId > 0)
      this.sharedService.openConfirm(
        "Are you sure you want to remove this contact? (You will still need to Update the treatment to completely remove the contact)"
      );
    else this.removeContact(id);

    this.sharedService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.removeContact(id);
      }
    });
  }

  removeContact(id: number) {
    this.contacts[id]["status"] = "deleted";
    this.cd.detectChanges();
  }
}
